import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import Sidebar from './Sidebar';
import Header from './Header';
import ErrorBoundary from '../ErrorBoundary';

export default function AppLayout({ currentSeries, pageTitle, pageSubtitle }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();

  return (
    <div
      className="min-h-screen bg-slate-50"
      style={currentSeries ? {
        '--series-color': currentSeries.color,
        '--series-color-light': `${currentSeries.color}15`,
        '--series-color-dark': currentSeries.color,
      } : undefined}
    >
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        currentSeries={currentSeries}
      />

      <Header
        sidebarCollapsed={sidebarCollapsed}
        onMenuClick={() => setSidebarCollapsed(!sidebarCollapsed)}
        title={pageTitle}
        subtitle={pageSubtitle}
      />

      <main
        className={clsx(
          'pt-14 min-h-screen transition-all duration-200',
          sidebarCollapsed ? 'ml-14' : 'ml-56'
        )}
      >
        <div className="p-5">
          <ErrorBoundary key={location.pathname}>
            <Outlet />
          </ErrorBoundary>
        </div>
      </main>
    </div>
  );
}
